/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetNewbuildingPolygonsModel,
  IGetNewbuildingPolygonsRequest,
  IMappers,
  IGetNewbuildingPolygonsResponse,
  IGetNewbuildingPolygonsResponseError,
  TGetNewbuildingPolygonsResponse,
} from './types';

const defaultConfig: TGetNewbuildingPolygonsModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'newbuilding-mvk',
  pathApi: '/v2/get-newbuilding-polygons/',
  hostType: 'api',
} as TGetNewbuildingPolygonsModel;

function createGetNewbuildingPolygonsModel(parameters: IGetNewbuildingPolygonsRequest): TGetNewbuildingPolygonsModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetNewbuildingPolygonsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetNewbuildingPolygonsRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetNewbuildingPolygons<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetNewbuildingPolygonsOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TGetNewbuildingPolygonsResponse
> {
  const { response, statusCode } = await httpApi.fetch(createGetNewbuildingPolygonsModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetNewbuildingPolygonsResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetNewbuildingPolygonsResponseError);
    }
  }

  return { response, statusCode } as TGetNewbuildingPolygonsResponse;
}

export { defaultConfig, createGetNewbuildingPolygonsModel, fetchGetNewbuildingPolygons };
